import React, { useState } from 'react';
import cn from 'classnames';
import moment from 'moment-timezone';

import { getIsMsgOutgoing } from 'widget/actions';
import { Text, Wrapper } from 'widget/components';
import { useChatBodyContext } from '../../../chat-body-context';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import { Position } from './message-env';
import Bubble from './bubble/bubble';
import ContextMenu from './context-menu/context-menu';
import MsgButtons from './msg-buttons/msg-buttons';
import MsgContext from './msg-context';
import ReactionPicker from './reaction-picker/reaction-picker';
import ReactionTrigger from './reaction-trigger/reaction-trigger';
import Userpic from './userpic/userpic';

interface Msg {
  isCollapsed: boolean;
  msg: Env.Message;
}

const Msg = ({ isCollapsed, msg }: Msg) => {
  const { tariff, widget } = useWidgetContext();
  const { accessToken } = useChatBodyContext();

  const [isContextMenuActive, setIsContextMenuActive] = useState(false);
  const [isReactionPickerActive, setIsReactionPickerActive] = useState(false);
  const [triggerPosition, setTriggerPosition] = useState<Position>();

  const handleContextMenu: React.MouseEventHandler<HTMLDivElement> = e => {
    e.preventDefault();
    setIsContextMenuActive(true);
    setTriggerPosition({ top: e.pageY, left: e.pageX });
  };

  const isOutgoing = getIsMsgOutgoing(accessToken, msg);

  const isReactionTrigger =
    msg.id != '-1' && msg.id != '-2' && tariff != null && tariff != 'Start';

  return (
    <MsgContext.Provider value={{ msg }}>
      <div
        className={cn('whatcrm-widget-message', {
          'whatcrm-widget-message_active': isContextMenuActive,
          'whatcrm-widget-message_collapsed': isCollapsed,
          'whatcrm-widget-message_outgoing': isOutgoing,
          [`whatcrm-widget-message_${widget.chat_message_type}`]:
            widget.chat_message_type,
        })}
        data-msg-id={msg.id}
        onContextMenu={handleContextMenu}
      >
        <Wrapper
          alignItems="center"
          gap={8}
          justifyContent={isOutgoing ? 'flex-end' : undefined}
        >
          <Wrapper alignItems="flex-end" gap={8} style={{ minWidth: 0 }}>
            {!isOutgoing && (
              <div className="whatcrm-widget-message__user">
                {!isCollapsed && <Userpic />}
              </div>
            )}

            <Bubble />
          </Wrapper>

          <Text
            className="whatcrm-widget-message__time"
            color="light"
            fontSize={12}
          >
            {moment(msg.timestamp).format('LT')}
          </Text>
        </Wrapper>

        {msg.buttons && <MsgButtons />}

        <ContextMenu
          isContextMenuActive={isContextMenuActive}
          setIsContextMenuActive={setIsContextMenuActive}
          triggerPosition={triggerPosition}
        >
          {isReactionTrigger && (
            <ReactionTrigger
              isContextMenuActive={isContextMenuActive}
              setIsContextMenuActive={setIsContextMenuActive}
              setIsReactionPickerActive={setIsReactionPickerActive}
            />
          )}
        </ContextMenu>

        <ReactionPicker
          isReactionPickerActive={isReactionPickerActive}
          setIsReactionPickerActive={setIsReactionPickerActive}
          triggerPosition={triggerPosition}
        />
      </div>
    </MsgContext.Provider>
  );
};

export default Msg;
